//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';



//  -- List books ----------------
export const invokeFeedback = () => ({ type: ActionTypes.feedback.invokeFeedback });
export const invokeFeedbackWithTeacherDescription = (teacherDescription, teacherName, audioUrl, email) => ({ 
    type: ActionTypes.feedback.invokeFeedbackWithTeacherDescription, 
    payload: { teacherDescription, teacherName, audioUrl, email } 
});
export const revokeFeedback = () => ({ type: ActionTypes.feedback.revokeFeedback });
export const setFeedbackReportResult = (result) => ({ type: ActionTypes.feedback.setFeedbackReportResult, payload: result });
export const clearFeedbackReportResult = () => ({ type: ActionTypes.feedback.clearFeedbackReportResult });
export const createFeedback = (returnedPayload) => ({ type: ActionTypes.feedback.createFeedback, payload: returnedPayload });
export const feedbackSuccess = (returnedPayload) => ({ type: ActionTypes.feedback.createFeedbackSuccess, payload: returnedPayload });

//  -- List All books ----------------
